var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var findOptions = function (_a) {
    var input = _a.input, value = _a.value, language = _a.language, _b = _a.startPosition, startPosition = _b === void 0 ? 0 : _b;
    var matched = {};
    for (var key in input) {
        var textValue = key || '';
        if (textValue.toLowerCase().startsWith(value.toLowerCase())) {
            matched[key] = __assign(__assign({}, input[key]), { start: startPosition });
        }
    }
    return matched;
};
export var tokenization = function (_a) {
    var input = _a.input, query = _a.query, language = _a.language, cursorPosition = _a.cursorPosition;
    if (!input) {
        return {};
    }
    var startPosition = query.lastIndexOf(' ', cursorPosition);
    var rootValues = query.split(',');
    var tokenizedInput = rootValues[rootValues.length - 1]
        .trimLeft()
        .split(' ');
    var selectedConcept = {};
    if (tokenizedInput.length >= 1) {
        var options = findOptions({
            input: input[input.conceptKey],
            value: tokenizedInput[0],
            language: language,
            startPosition: startPosition,
        });
        if (Object.keys(options).length === 1 &&
            Object.values(options)[0].label === tokenizedInput[0]) {
            selectedConcept = options;
        }
        else {
            return options;
        }
    }
    if (tokenizedInput.length >= 2) {
        for (var key in selectedConcept) {
            selectedConcept = findOptions({
                input: input[selectedConcept[key]['type']],
                value: tokenizedInput[1],
                language: language,
                startPosition: startPosition,
            });
        }
    }
    if (tokenizedInput.length >= 3) {
        for (var key in selectedConcept) {
            if (selectedConcept[key]['type']) {
                selectedConcept = findOptions({
                    input: input[selectedConcept[key]['type']],
                    value: '',
                    language: language,
                    startPosition: startPosition,
                });
                break;
            }
            else {
                selectedConcept = {};
            }
        }
    }
    return selectedConcept;
};
//# sourceMappingURL=suggestion-service.js.map